import React, { FC, useState, ReactNode, useEffect } from 'react'
import {
  UserIcon,
  UserCircleIcon,
  ClipboardListIcon,
  CreditCardIcon,
  ShieldCheckIcon,
  CheckIcon
} from '@heroicons/react/solid'
import useDisableScroll from '../../Modal/useDisableScroll'
import { StyledRegistrationLoader } from '.'

type Props = {
  currentProgress: string;
}

const RegistrationLoader: FC<Props> = ({ currentProgress }) => {
  const refBlock = useDisableScroll(true)
  // Maximum progress value (for radial progress bar)
  const totalProgress = 596.903
  const totalSteps = 6

  const [stepIcon, setStepIcon] = useState<ReactNode>()
  const [stepPercent, setStepPercent] = useState(-totalProgress)

  const getProgress = () => {
    if (currentProgress === 'Creating User') {
      setStepIcon(<UserIcon />)
      setStepPercent(-(5 / totalSteps) * totalProgress)
      return
    }
    if (currentProgress === 'Building Customer Profile') {
      setStepIcon(<UserCircleIcon />)
      setStepPercent(-(4 / totalSteps) * totalProgress)
      return
    }
    if (currentProgress === 'Creating Payment Profile') {
      setStepIcon(<ClipboardListIcon />)
      setStepPercent(-(3 / totalSteps) * totalProgress)
      return
    }
    if (currentProgress === 'Attaching Card to Account') {
      setStepIcon(<CreditCardIcon />)
      setStepPercent(-(2 / totalSteps) * totalProgress)
      return
    }
    if (currentProgress === 'Starting Subscription') {
      setStepIcon(<ShieldCheckIcon />)
      setStepPercent(-(1 / totalSteps) * totalProgress)
      return
    }

    setStepPercent(0)
    setStepIcon(<CheckIcon />)
  }

  useEffect(() => {
    getProgress()
  }, [currentProgress])

  return (
    <StyledRegistrationLoader stepPercent={stepPercent} ref={refBlock} tabIndex={-1}>
      <div className="progress-container">
        <div className="progress-circle">
          <svg className="progress-svg" width="105" height="105" viewBox="0 0 200 200">
            <circle
              className="progress-circle-background"
              cx="100"
              cy="100"
              r="95"
              strokeWidth="10px"
            />
            <circle
              className="progress-circle-progress"
              cx="100"
              cy="100"
              r="95"
              strokeWidth="10px"
              transform="rotate(-90 100 100)"
            />
          </svg>
          <div className="icon">{stepIcon}</div>
        </div>
        <span className="progress-title">We’re Almost Done</span>
        <span className="progress-description">{currentProgress}</span>
      </div>
    </StyledRegistrationLoader>
  )
}

export default RegistrationLoader
